import MuiListItem from '@mui/material/ListItem';
import styled from 'styled-components';

export const ListItem = styled(MuiListItem)`
  &.MuiListItem-root {
    padding-left: 0;
    padding-right: 0;
    display: inline-block;
  }
  .mlq {
    background-color: #f1d60a;
    display: inline-block;
    margin: 0px 3px 3px 3px;
    padding: 2px 4px;
    border-radius: 4px;
    width: 35px;
    text-align: center;
    color: #4c4f52;
  }
`;
